import { StorePagination } from "../../../../DashboardPagination"
import { fileActions } from "../../../../../store/files-slice"

const Pagination = ({ index }) => {
    return <StorePagination index={index} sliceName="file" actions={fileActions} label="Dateien Seitennavigation" />
}

export default Pagination;
